import request from '@/utils/request'

export function update(data) {
	return request({
		url: '/admin/privacy-policy',
		method: 'post',
		data
	})
}

export function getAll() {
	return request({
		url: '/admin/privacy-policy',
		method: 'get'
	})
}

export function get(locale='en') {
	return request({
		url: '/privacy-policy/'+locale,
		method: 'get'
	})
}